// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'arcadiaDisplay', 'arcadiaDisplay Fallback'"},"className":"__className_901108","variable":"__variable_901108"};